'use client'
import { useEffect } from 'react'

import useOffersGtmEvent from '@/src/hooks/analytics/gtm/offers'

/**
 * Client-only tracker: fires the `page_view_offers` GTM event once per load of
 * the offers listing page. Renders nothing — it exists solely so the event can
 * run in the browser (the listing page is otherwise fully server-rendered).
 */
const OffersPageViewTracker = () => {
    const { pushOffersPageViewEvent } = useOffersGtmEvent()

    useEffect(() => {
        pushOffersPageViewEvent()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return null
}

export default OffersPageViewTracker
